import React, {useState } from 'react';
import { FormGroup } from 'reactstrap';
import ErrorBoundary from '../../../ErrorBoundary';
import { NumericFormat } from 'react-number-format';

const InputNumericNumberCellRender = ({
    rowData,
    columnName,
    updateRowValue,
    required = false,
    validationError,
}) => {
    const value = rowData[columnName] ? rowData[columnName] : "";
    const [text, setText] = useState(value);

    const handlerChange = (values) => {
      if(columnName === "qtyInvoiced" || columnName === "invoicedPkgPrice"){
        setText(values.value);
        updateRowValue(values.value, columnName, rowData);
      }else{
       setText(values.floatValue);
       updateRowValue(values.floatValue, columnName, rowData);
      }
    };
    return (
      <div>
        <ErrorBoundary>
          <FormGroup>
            <NumericFormat
              type="text"
              name={columnName}
              id={columnName}
              decimalScale={2}
              allowNegative={false}
              allowLeadingZeros={false}
              value={text}
              onValueChange={handlerChange}
              autoComplete="off"
              className={required ? "required form-control" : ""}
            />
             {validationError && (
            <div className="text-danger">
              {validationError}
            </div>
          )}
          </FormGroup>
        </ErrorBoundary>
      </div>
    );
};

export default InputNumericNumberCellRender;
